import { makeAuthenticatedRequest } from "./authApi";
import { getApiUrl } from "../utils/envConfig";

// API-key management (FastAPI /api-keys/), the cross-tenant staff view over the
// Firestore `api_keys` collection.

// Dashmote staff: id_client is optional. Omit → keys across all workspaces;
// pass one → filter to that workspace. Staff always see both internal and
// customer keys.
export const listApiKeys = async (idClient) => {
  const query = idClient
    ? `?id_client=${encodeURIComponent(idClient)}`
    : "";
  return makeAuthenticatedRequest(`${getApiUrl()}/api-keys/${query}`);
};

export const createApiKey = async (payload) =>
  makeAuthenticatedRequest(`${getApiUrl()}/api-keys/`, {
    method: "POST",
    body: JSON.stringify(payload),
  });

// Enable or disable a key in place. Reversible, unlike a soft revoke — passing
// is_active:true turns a disabled key back on.
export const setApiKeyActive = async (keyId, isActive) =>
  makeAuthenticatedRequest(`${getApiUrl()}/api-keys/${keyId}`, {
    method: "PATCH",
    body: JSON.stringify({ is_active: isActive }),
  });

// Permanently remove the key document (staff only). The default DELETE is a
// soft revoke; `hard=true` deletes outright.
export const deleteApiKey = async (keyId) =>
  makeAuthenticatedRequest(`${getApiUrl()}/api-keys/${keyId}?hard=true`, {
    method: "DELETE",
  });
